import React from 'react';
import './SocialFeature.css';

const InstagramFeature = () => {
    const instagramUrl = "https://www.instagram.com/dannym__20";

    return (
        <div className="social-feature">
            <h2>Instagram Feed</h2>
            {/* Add Instagram embed code here */}
            <a 
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="social-button instagram-button"
            >
                Follow Me on Instagram
            </a>
        </div>
    );
};

export default InstagramFeature; 